import { createAction } from '@reduxjs/toolkit';
import { IResourceSkill } from '../../../../dto';
import { ACT_SET, TYPE_LIST, MN_RESOURCE_SKILLS } from '../../../../common';

export const setResourceSkills = createAction<IResourceSkill[]>(
  `${MN_RESOURCE_SKILLS}/${TYPE_LIST}/${ACT_SET}`,
);
